<template>
	<div class="wrap pt-16 pb-13 text-center">
		<h2 class="sub--title mb-2">
			{{ $t('action.sub-title') }}
		</h2>
		<h1 class="main--title font-weight-bold mb-6 mb-sm-10">
			{{ $t('action.title') }}
		</h1>
		<v-btn
			:href="`https://my.tella.co.kr/trial?_amp_d_id=${deviceId}`"
			min-width="200"
			height="64"
			x-large
			depressed
			color="white"
			@click="clickTrialBridge"
			><span class="primary--text font-weight-bold">{{
				$t('action.button')
			}}</span
			><v-img
				class="ml-1 mb-1"
				width="20"
				src="@/assets/images/raising-hands-icon.png"
			></v-img
		></v-btn>
	</div>
</template>

<script>
// import amplitude from 'amplitude-js'

export default {
	computed: {
		deviceId() {
			return this.$store.getters['deviceId']
		},
	},
	methods: {
		clickTrialBridge() {
			const urlPath = `${window.location.hostname}${this.$route.path}`
			// eslint-disable-next-line no-undef
			gtag('event', 'click_trial_bridge', {
				event_path: urlPath,
				category: '최하단 버튼',
			})
		},
		// clickBtn() {
		// 	this.sendEvent()
		// 	window.location.href = `https://my.tella.co.kr/trial?_amp_d_id=${this.deviceId}`
		// },
		// sendEvent() {
		// 	amplitude.getInstance().init('db978434b67054a87e4a40f950aae62c')
		// 	// const deviceId = this.$store.getters['deviceId']
		// 	const event = 'click_goToTrial'
		// 	const eventProperties = {
		// 		domain: 'tella.chat',
		// 		buttonName: this.$t('action.button'),
		// 		objectPlacement: 'Bottom',
		// 		path: this.$route.path,
		// 	}
		// 	amplitude.getInstance().logEvent(event, eventProperties)
		// 	// amplitude.getInstance().logEvent('EVENT_NAME_HERE')
		// },
	},
}
</script>

<style lang="scss" scoped>
.wrap {
	background-image: linear-gradient(to bottom, #4791fa, #67b3fe);
}

.sub--title {
	color: #fff;
}

.main--title {
	color: #fff;
}
</style>
